import axios from "@/plugins/axios";
import cps from "./cps";

let url = "/api/console/me";

export default {
    cps,
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}`, data).then(result => result.data);
    },
}
